<template>
  <div class="home-container" :class="modalTitle == '查看' ? '  ' : ''">
    <div class="home-content">
      <el-form :model="searchForm" ref="searchForm" label-width="80px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="标题/内容" label-width="120px" style="width: 80%">
              <el-input
                v-model="searchForm.keyword"
                placeholder="请输入标题/内容进行检索"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button
              size="small"
              @click="onLoad"
              type="primary"
              icon="el-icon-search"
              style="width: 90px"
              >搜索</el-button
            >
            <el-button
              size="small"
              @click="restSearch"
              type="danger"
              style="width: 90px"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </el-form>
      <!-- 搜索 -->
      <div style="margin: 20px">
        <!-- <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        > -->
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="title" label="消息标题" align="center">
        </el-table-column>
        <!-- <el-table-column prop="titleAssistant" label="信息描述" align="center">
        </el-table-column> -->
        <el-table-column prop="content" label="消息内容" align="center">
        </el-table-column>
        <!-- <el-table-column
          prop="sendType"
          label="发送类型"
          align="center"
          :formatter="onlineStatus"
        >
        </el-table-column> -->
        <el-table-column
          prop="target"
          label="推送用户"
          align="center"
          :formatter="personStatus"
        >
          <template slot-scope="scope">
            {{ scope.row.sendType == 0?'全部':'私发' }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="推送时间" align="center">
        </el-table-column>
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >查看</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog 
        title="详情"
        :visible.sync="isAddModal"
        width="50%"
        :close-on-click-modal="false">
        <el-form>
          <el-form-item label="消息标题">
            {{ addData.title }}
          </el-form-item>
          <el-form-item label="消息内容">
            {{ addData.content }}
          </el-form-item>
          <el-form-item label="推送用户">
            {{ addData.sendType == 0?'全部':addData.userNameList.join(',') }}
          </el-form-item>
          <el-form-item label="推送时间">
            {{ addData.createTime }}
          </el-form-item>
          
        </el-form>

      </el-dialog>
    </div>
  </div>
</template>

<script>
import ueditor from "../../components/ueditor";
import reg from "../../utils/reg";
export default {
  components: {
    ueditor,
  },
  data() {
    return {
      searchForm: {
        name: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 0, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        title: "",
        sendType: "",
        type: "",
        target: "",
        titleAssistant: "",
        content: "",
        radioType: 1,
        ridgepoleId: "",
        unitId: "",
        floorId: "",
        roomId: "",
        manageUserId: "",
      },
      addDataRules: {
        title: [{ required: true, message: "请输入消息标题", trigger: "blur" }],
        sendType: [
          { required: true, message: "请选择发送类型", trigger: "blur" },
        ],
        target: [
          { required: true, message: "请选择发送目标", trigger: "blur" },
        ],
        type: [{ required: true, message: "请选择消息类型", trigger: "blur" }],
        ridgepoleId: [
          { required: true, message: "请选择楼栋信息", trigger: "blur" },
        ],
        unitId: [
          { required: true, message: "请选择单元信息", trigger: "blur" },
        ],
        floorId: [
          { required: true, message: "请选择楼层信息", trigger: "blur" },
        ],
        roomId: [
          { required: true, message: "请选择房间信息", trigger: "blur" },
        ],
        manageUserId:[
          { required: true, message: "请选择物业人员", trigger: "blur" },
        ],
        content: [
          { required: true, message: "请输入消息内容", trigger: "blur" },
        ],
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      ridgepoleList: [],
      unitList: [],
      floorList: [],
      roomList: [],
      propertyList: [],
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {
    changeFlags() {
      if (this.addData.radioType == 1) {
        this.addData.ridgepoleId = [];
        this.addData.unitId = "";
        this.addData.floorId = "";
        this.addData.roomId = "";
      } else if (this.addData.radioType == 2) {
        this.addData.ridgepoleId = null;
        this.addData.unitId = [];
        this.addData.floorId = "";
        this.addData.roomId = "";
      } else if (this.addData.radioType == 3) {
        this.addData.ridgepoleId = "";
        this.addData.unitId = "";
        this.addData.floorId = [];
        this.addData.roomId = "";
      } else if (this.addData.radioType == 4) {
        this.addData.ridgepoleId = "";
        this.addData.unitId = "";
        this.addData.floorId = "";
        this.addData.roomId = [];
      }
      (this.unitList = []), (this.floorList = []), (this.roomList = []);
    },
    // 选择楼栋
    ridgepoleSelect(e,index) {
      if (this.addData.radioType != 1 || this.addData.sendType == -1) {
        this.$Apis.unitAllList({ ridgepoleId: e }).then((res) => {
          if (res.code == 200) {
            if(index != 1){
              this.addData.unitId = ''
              this.addData.floorId = ''
              this.addData.roomId = ''
            }
            this.unitList = res.data;
          }
        });
      }
    },
    // 选择单元
    unitSelect(e, index) {
      if (
        (this.addData.radioType != 1 && this.addData.radioType != 2) ||
        this.addData.sendType == -1
      ) {
        this.$Apis.floorAllList({ unitId: e }).then((res) => {
          if (res.code == 200) {
            if(index != 1){
              this.addData.floorId = ''
              this.addData.roomId = ''
            }
            this.floorList = res.data;
          }
        });
      }
    },
    // 选择楼层
    floorSelect(e,index) {
      if (
        (this.addData.radioType != 1 &&
          this.addData.radioType != 2 &&
          this.addData.radioType != 3) ||
        this.addData.sendType == -1
      ) {
        this.$Apis.roomAllList({ floorId: e }).then((res) => {
          if (res.code == 200) {
            if(index != 1){
              this.addData.roomId = ''
            }
            this.roomList = res.data;
          }
        });
      }
    },
    // 消息类型
    msgStatus(row) {
      if (row.type == 0) {
        return "通知消息";
      } else if (row.type == 1) {
        return "订单通知";
      } else if (row.type == 2) {
        return "意见反馈";
      }
    },
    // 发送类型
    onlineStatus(row) {
      if (row.sendType == 0) {
        return "群发";
      } else if (row.sendType == 1) {
        return "私发";
      } 
      // else if (row.sendType == -1) {
      //   return "私发";
      // }
    },
    // 发送目标
    personStatus(row) {
      if (row.target == 0) {
        return "全部";
      } else if (row.target == 1) {
        return "用户";
      } else if (row.target == 2) {
        return "物业";
      }
    },
    // 新增
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.addData.radioType = 1;
      this.modalTitle = "新增";
      this.isAddModal = true;
    },
    // 查看
    updataCharacter(row) {
      // this.addData = JSON.parse(JSON.stringify(row));
      this.$Apis.messageDetail({
        id:row.id
      }).then(res=>{
        if(res.code == 200){
          this.isAddModal = true
          this.addData = res.data
        }
      })
      this.modalTitle = "查看";
      // if (this.addData.target == 1) {
      //   if (this.addData.sendType == -1) {
      //     this.addData.ridgepoleId = Number(this.addData.ridgepoleId);
      //     this.addData.floorId = Number(this.addData.floorId);
      //     this.addData.unitId = Number(this.addData.unitId);
      //     this.addData.roomId = Number(this.addData.roomId);
      //     this.ridgepoleSelect(this.addData.ridgepoleId,1);
      //     this.unitSelect(this.addData.unitId,1);
      //     this.floorSelect(this.addData.floorId,1);
      //     this.isAddModal = true;
      //   } else if (this.addData.sendType == 1) {
      //     if (this.addData.roomId) {
      //       this.addData.ridgepoleId = Number(this.addData.ridgepoleId);
      //       this.addData.floorId = Number(this.addData.floorId);
      //       this.addData.unitId = Number(this.addData.unitId);
      //       this.addData.roomId = this.addData.roomId.split(",");
      //       this.addData.roomId = this.addData.roomId.map(Number);
      //       this.addData.radioType = 4;
      //       this.ridgepoleSelect(this.addData.ridgepoleId,1);
      //       this.unitSelect(this.addData.unitId,1);
      //       this.floorSelect(this.addData.floorId,1);
      //       this.isAddModal = true;
      //       return
  
      //     } else if (this.addData.floorId) {
      //       this.addData.ridgepoleId = Number(this.addData.ridgepoleId);
      //       this.addData.unitId = Number(this.addData.unitId);
      //       this.addData.floorId = this.addData.floorId.split(",");
      //       this.addData.floorId = this.addData.floorId.map(Number);
      //       this.ridgepoleSelect(this.addData.ridgepoleId,1);
      //       this.unitSelect(this.addData.unitId,1);
      //       this.addData.radioType = 3;
      //       this.isAddModal = true;
      //       return;
      //     } else if (this.addData.unitId) {
      //       this.addData.ridgepoleId = Number(this.addData.ridgepoleId);
      //       this.addData.floorId = Number(this.addData.floorId);
      //       this.addData.unitId = this.addData.unitId.split(",");
      //       this.addData.unitId = this.addData.unitId.map(Number);
      //       this.ridgepoleSelect(this.addData.ridgepoleId,1);
      //       this.addData.radioType = 2;
      //       this.isAddModal = true;
      //       return;
      //     } else if (this.addData.ridgepoleId) {
      //       this.addData.ridgepoleId = this.addData.ridgepoleId.split(",");
      //       this.addData.ridgepoleId = this.addData.ridgepoleId.map(Number);
      //       this.addData.radioType = 1;
      //       this.isAddModal = true;
      //       return;
      //     } else {
      //       this.isAddModal = true;
      //     }
      //   }
      // } else {
      //   this.addData.manageUserId = Number(this.addData.manageUserId);
      //   this.isAddModal = true;
      // }
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.messageDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      if (this.modalTitle == "查看") {
        this.btnLoading = false;
        this.isAddModal = false;
        return;
      }
      this.$refs["form"].validate((valid) => {
        if (valid) {
          var data = {
            content: this.addData.content,
            floorId:
              reg.array(this.addData.floorId) == true
                ? this.addData.floorId.join(",")
                : this.addData.floorId,
            ridgepoleId:
              reg.array(this.addData.ridgepoleId) == true
                ? this.addData.ridgepoleId.join(",")
                : this.addData.ridgepoleId,
            unitId:
              reg.array(this.addData.unitId) == true
                ? this.addData.unitId.join(",")
                : this.addData.unitId,
            roomId:
              reg.array(this.addData.roomId) == true
                ? this.addData.roomId.join(",")
                : this.addData.roomId,
            sendType: this.addData.sendType,
            target: this.addData.target,
            title: this.addData.title,
            titleAssistant: this.addData.titleAssistant,
            object: this.addData.object,
            manageUserId: this.addData.manageUserId || "",
          };
          this.$Apis.messageAdd(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },
    onLoad() {
      this.isShowloading = true;
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        ...this.searchForm
      };
      this.$Apis.houseAllList().then((res) => {
        if (res.code == 200) {
          this.ridgepoleList = res.data;
        }
      });
     
      this.$Apis.messageList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          list.forEach((item, ind) => {
            item.ind = ind + 1;
          });
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style  scoped>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}

/deep/.warpper .el-input.is-disabled .el-input__inner {
  color: #333;
  font-weight: bold;
  border: none;
  background: #fff;
}
/deep/.warpper .el-input.is-disabled .el-input__icon {
  display: none;
}
</style>